function Input({ labelText, inputOptions, errorText, required }) {
    return (
        <div className='flex flex-col gap-2'>
            <div className="flex items-center justify-between">
                <label className='select-none cursor-pointer w-fit font-medium text-base text-[#121212]' htmlFor={inputOptions.id}>{labelText}{required && <span className="text-[#DC2626]">*</span>}</label>
    
                {
                    errorText && 
                    <p className='text-[14px] leading-5 text-[#DC2626] select-none'>{errorText}</p>
                }
            </div>

            <input 
                className='outline-none px-3 py-4 bg-[#F5F5F5] border border-[#EAEAEA] rounded-[9px] font-normal text-base text-[#121212] focus:border-primaryColor' 
                { ...inputOptions } 
            />
        </div>
    );
}

export default Input;
